// ============================================================
// audio/context.js — AudioContext initialisation & reverb
// ============================================================
import { state } from '../state.js';
import { AudioCtx } from '../constants.js';

/** Create the shared AudioContext (idempotent). */
export function initAudio() {
  if (state.audioCtx) return;
  state.audioCtx = new AudioCtx();
}

/** Create a convolver-based reverb node on the current context. */
export function createReverb() {
  const convolver = state.audioCtx.createConvolver();
  const rate = state.audioCtx.sampleRate;
  const length = rate * 2.5;
  const impulse = state.audioCtx.createBuffer(2, length, rate);
  for (let ch = 0; ch < 2; ch++) {
    const data = impulse.getChannelData(ch);
    for (let i = 0; i < length; i++) {
      data[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / length, 2.2);
    }
  }
  convolver.buffer = impulse;
  return convolver;
}
